import MuiTabs from '@mui/material/Tabs'
import MuiTab from '@mui/material/Tab'
import styled from '@emotion/styled'

export const Tabs = styled(MuiTabs)`
  ${({ theme }) => `
    .MuiTabScrollButton-root {
      &.Mui-disabled {
        opacity: unset;
        color: ${theme.palette.text.disabled};
      }

      > .MuiSvgIcon-fontSizeSmall {
        font-size: ${theme.typography.h5.fontSize};
      }
    }

    .MuiTabs-indicator {
      height: 4px;
    }
  `}
`

export const Tab = styled(MuiTab)`
  ${({ theme }) => `
    &.MuiTab-root {
      min-width: unset;
      padding: ${theme.spacing(3)} ${theme.spacing(4)};
      font-size: ${theme.typography.h6.fontSize};
      font-weight: initial;

      &.Mui-selected {
        font-weight: 700;
      }

      ${theme.breakpoints.up('lg')} {
        padding: ${theme.spacing(3)} ${theme.spacing(6)};
      }
    }
  `}
`
